import type { SVGProps } from "react";
import * as React from "react";
const SvgMicrosoftExcel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#91C174" d="M4 4a2 2 0 0 1 2-2h6v5H4V4Z" />
    <path fill="#418B5C" d="M4 12h8v5H4z" />
    <path fill="#6AA668" d="M4 7h8v5H4z" />
    <path fill="#418B5C" d="M4 17h8v5H6a2 2 0 0 1-2-2v-3Z" />
    <path fill="#BCDE81" d="M12 2h6a2 2 0 0 1 2 2v3h-8V2Z" />
    <path fill="#6AA668" d="M12 12h8v5h-8z" />
    <path fill="#91C174" d="M12 7h8v5h-8z" />
    <path fill="#418B5C" d="M12 17h8v3a2 2 0 0 1-2 2h-6v-5Z" />
    <path
      fill="#105B2B"
      d="M2.833 7h8.334c.46 0 .833.373.833.833v8.334c0 .46-.373.833-.833.833H2.833A.833.833 0 0 1 2 16.167V7.833c0-.46.373-.833.833-.833Z"
    />
    <path
      fill="#fff"
      d="m4.3 15 1.941-3.008L4.463 9h1.43l.971 1.913c.09.182.151.317.184.406h.013c.064-.145.131-.286.201-.422L8.3 9h1.314L7.79 11.975 9.66 15H8.262l-1.12-2.1a1.76 1.76 0 0 1-.135-.28h-.016a1.327 1.327 0 0 1-.13.271L5.706 15H4.3Z"
    />
  </svg>
);
export default SvgMicrosoftExcel;
